var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#006F9B",
    stroke: "#006F9B",
    strokeWidth: 0.727273,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36364 11.3636H6.63636V12.6364H1.36364V11.3636ZM7.05 6.15426L8.65574 7.76L7.76 8.65574L6.15426 7.05L7.05 6.15426ZM11.3636 6.63636V1.36364H12.6364V6.63636H11.3636ZM17.8457 7.05L16.24 8.65574L15.3443 7.76L16.95 6.15426L17.8457 7.05ZM22.6364 12.6364H17.3636V11.3636H22.6364V12.6364ZM9.36364 12C9.36364 10.5408 10.5408 9.36364 12 9.36364C13.4592 9.36364 14.6364 10.5408 14.6364 12C14.6364 13.4592 13.4592 14.6364 12 14.6364C10.5408 14.6364 9.36364 13.4592 9.36364 12ZM16.95 17.8457L15.3443 16.24L16.24 15.3443L17.8457 16.95L16.95 17.8457ZM7.05 17.8457L6.15426 16.95L7.76 15.3443L8.65574 16.24L7.05 17.8457ZM12.6364 17.3636V22.6364H11.3636V17.3636H12.6364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlare);
export default __webpack_public_path__ + "static/media/flare.cba0bd0d264a625855e77d975f9ce2ed.svg";
export { ForwardRef as ReactComponent };